import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 从 localStorage 读取配置
function loadAudioParams() {
  const saved = localStorage.getItem('audio_params')
  if (saved) {
    try {
      return JSON.parse(saved)
    } catch (e) {
      console.error('Failed to parse audio params:', e)
    }
  }
  return null
}

function loadHotSaleParams() {
  const saved = localStorage.getItem('hot_sale_params')
  if (saved) {
    try {
      return JSON.parse(saved)
    } catch (e) {
      console.error('Failed to parse hot sale params:', e)
    }
  }
  return null
}

const loadedHotSaleParams = null
const loadedAudioParams = null

// 强制重置音效开关为关闭状态，确保新用户默认不启动音效
if (loadedAudioParams) {
  loadedAudioParams.audioEffectsEnabled = false
  loadedAudioParams.randomMode = null
}

const defaultHotSaleParams = {
  hotImageEffect: {
    enabled: false,
    count: 0,
    imagePath: "",
    bottom: 20,
    left: 20,
    fontSize: 24,
    frequency: 5,
    mode: 'single',
    startMin: 100,
    startMax: 200,
    increaseMin: 10,
    increaseMax: 50,
  },
  inventoryEffect: {
    enabled: false,
    count: 100,
    imagePath: "",
    bottom: 20,
    left: 20,
    fontSize: 24,
    frequency: 6,
    mode: 'single',
    startMin: 50,
    startMax: 200,
    decreaseMin: 5,
    decreaseMax: 30,
  },
  purchaseEffect: {
    enabled: false,
    frequencyMin: 2,
    frequencyMax: 10,
    purchaseMin: 1,
    purchaseMax: 10,
    fontSize: 16,
    visible: false,
    currentCount: 0,
    currentUser: "",
    bottom: 20,
    left: 20,
  },
  textScrollEffect: {
    enabled: false,
    speed: 1,
    fontSize: 20,
    color: "#ffffff",
    backgroundColor: "rgba(0,0,0,0.5)",
    bottom: 100,
    left: 50,
    opacity: 100,
    items: ['欢迎来到直播间！', '喜欢的话请点个关注~', '感谢大家的支持！'],
    width: 160,
    height: 120,
  },
  marqueeEffect: {
    enabled: false,
    speed: 1,
    fontSize: 18,
    color: "#ffeb3b",
    backgroundColor: "rgba(0,0,0,0.3)",
    bottom: 50,
    left: 0,
    opacity: 100,
    items: ['限时特惠！', '买一送一！', '最后一天！'],
  },
  flashTextEffect: {
    enabled: false,
    speed: 1,
    fontSize: 28,
    color: "#ff5722",
    backgroundColor: "rgba(0,0,0,0.6)",
    bottom: 150,
    left: 50,
    opacity: 100,
    text: "抢购中...",
  },
}

const defaultAudioParams = {
  audioEffectsEnabled: false, // 新增：全局音效开关，默认关闭
  volumeEnabled: false, // 音量保持默认开启
  volume: 100,
  playbackRateEnabled: false,
  playbackRate: 1,
  // 向后兼容
  speed: 1,
  pitchEnabled: false,
  pitch: 0,
  compressorEnabled: false,
  compressorThreshold: -40,
  bassEnabled: false,
  bass: 0,
  noiseEnabled: false,
  noiseLevel: 0,
  // 向后兼容
  noiseFloor: 0,
  echoEnabled: false,
  echoLevel: 0,
  vocalClarityEnabled: false,
  vocalClarityLevel: 0,
  panEnabled: false,
  pan: 0,
  aiDedupEnabled: false,
  aiDedupIntensity: 50,
  // 向后兼容
  aiDedup: false,
  aiRecomposeEnabled: false,
  aiRecomposeIntensity: 50,
  // 向后兼容
  aiRecompose: false,
  randomMode: null
}

export default new Vuex.Store({
  state: {
    audioFiles:[],
    currentMedia: null,
    isVirtualCameraLive: false,
    hotSaleParams: loadedHotSaleParams || defaultHotSaleParams,
    audioParams: {
      ...defaultAudioParams,
      ...(loadedAudioParams || {}),
      audioEffectsEnabled: false, // 强制默认关闭
      randomMode: null // 确保随机模式也关闭
    },
    smartOverlayParams: {
      enabled: false,
      rotationIntervalMin: 30,
      rotationIntervalMax: 60,
      multiLineText: "爆款推荐\n限时秒杀\n关注领券\n新品上市\n好评如潮",
      instantText: "",
      stickerX: 70,
      stickerY: 12,
      aiAnalysisEnabled: false,
      targetPosition: { x: 50, y: 50 },
      replyEnabled: false,
      currentTemplate: 'default',
      replies: []
    },
    liveFloatParams: {
      enabled: false,
      speed: 1,
      fontSize: 14,
      areaTop: true,
      areaBottom: true,
      messages: ['666', '好看', '主播加油！', '关注了']
    },
    dynamicTitleParams: {
      enabled: false,
      currentGroupId: 1,
      autoGroupSwitch: false,
      intervalMin: 5,
      intervalMax: 15,
      firstTitleText: "爆款女装，限时 3 折起！速抢！",
      firstTitleBg: "#ff0000",
      firstTitleBgOpacity: 80,
      firstTitleColor: "#ffffff",
      firstTitleShadow: "#000000",
      firstTitleSize: 14,
      firstTitleLetterSpacing: 1,
      secondTitleText: "限时秒杀，仅此一天！速抢！",
      secondTitleBg: "#00d4ff",
      secondTitleBgOpacity: 80,
      secondTitleColor: "#ffffff",
      secondTitleShadow: "#000000",
      secondTitleSize: 13,
      secondTitleLetterSpacing: 0.5,
      thirdTitleText: "官方正品保障，假一赔十",
      thirdTitleBg: "#9c27b0",
      thirdTitleBgOpacity: 80,
      thirdTitleColor: "#ffffff",
      thirdTitleShadow: "#000000",
      thirdTitleSize: 12,
      thirdTitleLetterSpacing: 0,
      title1Pos: { x: 20, y: 60 },
      title2Pos: { x: 20, y: 100 },
      title3Pos: { x: 20, y: 135 },
      decorationsEnabled: true,
      decorations: []
    },
    overlay_play_type:"local",
    token:null,
    userInfo:null,
    serverUrl:null,
  },
  getters: {

  },
  mutations: {

    setServerUrl(state,url){

      state.serverUrl=url
    },


    setUserInfo(state,info){
        state.userInfo=info;
    },

    setToken(state,token){
      localStorage.setItem("token",token)

      state.token=token;
    },
    setOverlayPlayType(state,type){

      state.overlay_play_type=type

    },

    UPDATE_HOT_SALE_PARAMS(state, payload) {
      Object.assign(state.hotSaleParams, payload)
      saveHotSaleParams(state.hotSaleParams)
    },
    UPDATE_SMART_OVERLAY_PARAMS(state, payload) {
      Object.assign(state.smartOverlayParams, payload)
    },
    UPDATE_DYNAMIC_TITLE_PARAMS(state, payload) {
      Object.assign(state.dynamicTitleParams, payload)
    },

    SET_IS_PLAYING(state,data) {

      state.currentMedia.isPlaying=data;
    },

    SET_AUDIO_FILES(state, files) {
      state.audioFiles = files
    },
    UPDATE_AUDIO_PARAMS(state, payload) {
      const oldMode = state.audioParams.randomMode

      // 核心修复：使用 Object.assign 确保属性级别的更新，而不是替换整个对象引用
      // 这能保证 randomMode 等顶级属性不会在 Partial 更新中被意外丢失
      Object.assign(state.audioParams, payload)

      console.log('[Store] UPDATE_AUDIO_PARAMS:', payload, 'New Mode:', state.audioParams.randomMode)

      // 新增：如果全局音效开关关闭，强制禁用随机模式
      if (!state.audioParams.audioEffectsEnabled) {
        state.audioParams.randomMode = null
      }

      // 如果 randomMode 发生了变化（从 null 变到某个值），立即执行一次随机化
      if (payload.randomMode && payload.randomMode !== oldMode && state.audioParams.audioEffectsEnabled) {
        const mode = payload.randomMode
        const next = {}
        if (mode === 'light') {
          next.volume = 97 + Math.random() * 6
          next.volumeEnabled = true
          next.speed = 0.995 + Math.random() * 0.01
          next.playbackRateEnabled = true
          next.pitch = Math.floor(Math.random() * 40 - 20)
          next.pitchEnabled = true
          next.bass = Math.random() * 3
          next.bassEnabled = true
          next.noiseFloor = 0
          next.noiseEnabled = false
          next.vocalClarityLevel = 1 + Math.random() * 2
          next.vocalClarityEnabled = true
          next.aiDedup = true
          next.aiDedupEnabled = true
          next.aiDedupIntensity = 10 + Math.random() * 20
          next.aiRecompose = false
          next.aiRecomposeEnabled = false
        } else if (mode === 'medium') {
          next.volume = 94 + Math.random() * 12
          next.volumeEnabled = true
          next.speed = 0.98 + Math.random() * 0.04
          next.playbackRateEnabled = true
          next.pitch = Math.floor(Math.random() * 200 - 100)
          next.pitchEnabled = true
          next.bass = 4 + Math.random() * 6
          next.bassEnabled = true
          next.noiseFloor = 1 + Math.random() * 3
          next.noiseEnabled = true
          next.vocalClarityLevel = 3 + Math.random() * 3
          next.vocalClarityEnabled = true
          next.compressorThreshold = -35 - Math.random() * 15
          next.compressorEnabled = true
          next.aiDedup = true
          next.aiDedupEnabled = true
          next.aiDedupIntensity = 40 + Math.random() * 30
          next.aiRecompose = Math.random() > 0.5
          next.aiRecomposeEnabled = next.aiRecompose
          next.aiRecomposeIntensity = next.aiRecompose ? 20 + Math.random() * 20 : 0
        } else if (mode === 'heavy') {
          next.volume = 90 + Math.random() * 20
          next.volumeEnabled = true
          next.speed = 0.96 + Math.random() * 0.08
          next.playbackRateEnabled = true
          next.pitch = Math.floor(Math.random() * 600 - 300)
          next.pitchEnabled = true
          next.bass = 8 + Math.random() * 12
          next.bassEnabled = true
          next.noiseFloor = 4 + Math.random() * 6
          next.noiseEnabled = true
          next.vocalClarityLevel = 5 + Math.random() * 5
          next.vocalClarityEnabled = true
          next.compressorThreshold = -50 - Math.random() * 30
          next.compressorEnabled = true
          next.aiDedup = true
          next.aiDedupEnabled = true
          next.aiDedupIntensity = 70 + Math.random() * 30
          next.aiRecompose = true
          next.aiRecomposeEnabled = true
          next.aiRecomposeIntensity = 50 + Math.random() * 50
        }
        Object.assign(state.audioParams, next)
      }

      saveAudioParams(state.audioParams)
    },

    // 新增：执行一次随机参数计算
    PERFORM_GLOBAL_RANDOMIZE(state) {
      // 如果全局音效开关关闭，不执行随机化
      if (!state.audioParams.audioEffectsEnabled) return

      const mode = state.audioParams.randomMode
      if (!mode) return

      const next = {}
      if (mode === 'light') {
        next.volume = 97 + Math.random() * 6
        next.volumeEnabled = true
        next.speed = 0.995 + Math.random() * 0.01
        next.playbackRateEnabled = true
        next.pitch = Math.floor(Math.random() * 40 - 20)
        next.pitchEnabled = true
        next.bass = Math.random() * 3
        next.bassEnabled = true
        next.noiseFloor = 0
        next.noiseEnabled = false
        next.vocalClarityLevel = 1 + Math.random() * 2
        next.vocalClarityEnabled = true
        next.compressorThreshold = -20 - Math.random() * 10
        next.compressorEnabled = true
        next.aiDedup = Math.random() > 0.5
        next.aiDedupEnabled = next.aiDedup
        next.aiDedupIntensity = next.aiDedup ? 10 + Math.random() * 20 : 0
        next.aiRecompose = false
        next.aiRecomposeEnabled = false
      } else if (mode === 'medium') {
        next.volume = 94 + Math.random() * 12
        next.volumeEnabled = true
        next.speed = 0.98 + Math.random() * 0.04
        next.playbackRateEnabled = true
        next.pitch = Math.floor(Math.random() * 200 - 100)
        next.pitchEnabled = true
        next.bass = 4 + Math.random() * 6
        next.bassEnabled = true
        next.noiseFloor = 1 + Math.random() * 3
        next.noiseEnabled = true
        next.vocalClarityLevel = 3 + Math.random() * 3
        next.vocalClarityEnabled = true
        next.compressorThreshold = -35 - Math.random() * 15
        next.compressorEnabled = true
        next.aiDedup = true
        next.aiDedupEnabled = true
        next.aiDedupIntensity = 30 + Math.random() * 30
        next.aiRecompose = Math.random() > 0.5
        next.aiRecomposeEnabled = next.aiRecompose
        next.aiRecomposeIntensity = next.aiRecompose ? 20 + Math.random() * 20 : 0
      } else if (mode === 'heavy') {
        next.volume = 90 + Math.random() * 20
        next.volumeEnabled = true
        next.speed = 0.96 + Math.random() * 0.08
        next.playbackRateEnabled = true
        next.pitch = Math.floor(Math.random() * 600 - 300)
        next.pitchEnabled = true
        next.bass = 8 + Math.random() * 12
        next.bassEnabled = true
        next.noiseFloor = 4 + Math.random() * 6
        next.noiseEnabled = true
        next.vocalClarityLevel = 5 + Math.random() * 5
        next.vocalClarityEnabled = true
        next.compressorThreshold = -50 - Math.random() * 30
        next.compressorEnabled = true
        next.aiDedup = true
        next.aiDedupEnabled = true
        next.aiDedupIntensity = 60 + Math.random() * 40
        next.aiRecompose = true
        next.aiRecomposeEnabled = true
        next.aiRecomposeIntensity = 50 + Math.random() * 50
      }
      
      Object.assign(state.audioParams, next)
    },


    UPDATE_MEDIA_STATE(state, payload) {
      if (state.currentMedia) {
        Object.assign(state.currentMedia, payload)
      }
      //console.log('[Store] UPDATE_MEDIA_STATE:', payload)
    },

    SET_CURRENT_MEDIA(state, data) {

      if (data) {
        const isSameSource = state.currentMedia && state.currentMedia.url === data.url;
        const savedTime = isSameSource ? state.currentMedia?.currentTime : 0;
        const savedPlaying = isSameSource ? state.currentMedia?.isPlaying : false;
        state.currentMedia = {
          currentTime: savedTime,
          isPlaying: savedPlaying,
          volume: 1,
          duration: 0,
          ...data
        }

      } else {
        state.currentMedia = null
      }


    }
  },
  actions: {
    setAudioFiles({ commit }, files) {
      commit('SET_AUDIO_FILES', files)
    },
    setCurrentMedia({ commit }, media) {
      commit('SET_CURRENT_MEDIA', media)
    },
    // 启动全局随机化循环
    startGlobalAudioRandomizer({ commit, state }) {
      setInterval(() => {
        if (state.audioParams.randomMode) {
          commit('PERFORM_GLOBAL_RANDOMIZE')
        }
      }, 2000)
    }
  },
  modules: {}
})
function saveAudioParams(params) {
  localStorage.setItem('audio_params', JSON.stringify(params))
}
function saveHotSaleParams(params) {
  localStorage.setItem('hot_sale_params', JSON.stringify(params))
}